import Audio from '@/models/Audio'
import Api from '@/services/api'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      per_page: 10,
      last_page: 1
    }
  },

  mutations: {
    setAudioList (state, audios) {
      state.list = audios
    },

    clearAudioList (state) {
      state.list = []
    },

    setAudioListMeta (state, meta) {
      state.listMeta = meta
    },

    setAudioDetails (state, audio) {
      if (audio instanceof Audio) {
        state.audioDetails = audio
      } else {
        state.audioDetails = new Audio(audio)
      }
    },

    clearAudioDetails (state) {
      state.audioDetails = {
        title: '',
        description: '',
        license: null,
        license_description: '',
        category: [],
        author: [],
        status: null,
        photo: []
      }
    }
  },

  actions: {
    clearAudioDetails ({ commit }) {
      commit('clearAudioDetails')
    },

    async updateAudio ({ commit }, formData) {
      const { data } = await Api.post(
        `audios/${formData.get('id')}`,
        formData
      )
      commit('setAudioDetails', data.data)
    },

    async deleteAudio ({ commit }, audioId) {
      const { data } = await Api.delete(`audios/${audioId}`)
      commit('setAudioDetails', data.data)
    },

    async getAudios ({ commit }, params) {
      const query = Audio.page(params.page || 1)

      query.include(['photo', 'author', 'category'])

      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query.params({ limit: 10 }).get()

      commit('setAudioList', res.data)
      commit('setAudioListMeta', res.meta)
    },

    async getAudioDetails ({ commit }, id) {
      const { data } = await Api.get(`admin/audio/${id}`)
      commit('setAudioDetails', data.data)
    },

    async getAllAudios ({ commit }) {
      const { data } = await Api.get(`admin/audios`)
      commit('setAudioList', data.data)
    }

  }
}
